export enum AlertMessageIcon {
  SUCCESS = 'checkmark-circle-outline',
  INFO = 'alert-circle-outline',
  ERROR = 'close-circle-outline',
}
